import type {
  IFetchOrganizationsListParams,
  IItem,
  IOrganizationAliasesRedirects,
  IOrganizationMenuQuery,
  OrganizationType,
} from '../interfaces/organizations';

import ProxyClient from './clients/ProxyClient';

export const loadOrganizationsList = async (params: IFetchOrganizationsListParams): Promise<IItem[]> => {
  const { data } = await ProxyClient.get<IItem[]>('/organizations', { params });
  return data;
};

export const loadOrganizationByAlias = async (organizationType: OrganizationType, alias: string) => {
  const { data } = await ProxyClient.get<IItem>(`/organizations/${alias}`, {
    params: { organizationType },
  });
  return data;
};

export const loadOrganizationRedirects = async () => {
  const { data } = await ProxyClient.get<{ redirects: IOrganizationAliasesRedirects }>('/organizations/redirects');
  return data;
};

export const loadOrganizationMenu = async (params: IOrganizationMenuQuery) => {
  const { data } = await ProxyClient.get('/organizations/menu', { params });
  return data;
};
